import { render, staticRenderFns } from "./AdditionaModel.vue?vue&type=template&id=1f1cbb44&scoped=true&"
import script from "./AdditionaModel.vue?vue&type=script&lang=js&"
export * from "./AdditionaModel.vue?vue&type=script&lang=js&"
import style0 from "./AdditionaModel.vue?vue&type=style&index=0&id=1f1cbb44&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1cbb44",
  null
  
)

export default component.exports